import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NavigationComponent } from '../../layout/navigation/navigation.component';

@Component({
  selector: 'login-page',
  standalone: true,
  imports: [FormsModule, CommonModule, NavigationComponent],
  templateUrl: './login-page.component.html',
})
export class LoginPageComponent implements OnInit {
  ngOnInit(): void {}
}
